import React from 'react';
import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import ProductVariationsProp from '../../shop/propTypes/productVariationsProp';
import translate from '../../../commonComponents/translate';
import { PACK_TYPE } from '../../shop/propTypes/productProp';

function ProductItem({ t, item }) {
  const {
    isPack,
    images,
    icon,
    name,
    isOutOfStock,
    packType,
    packVariations,
    amountVariationsPerAdvancedPack,
    notAvailableInCountry,
    parentProduct,
  } = item || {};
  const isAdvancedPack = packType === 'advanced';
  const isHybridPack = packType === PACK_TYPE.HYBRID_PACK;
  let title = isAdvancedPack ? t('shop.advancedPack') : t('shop.pack');
  if (isHybridPack) {
    title = t('shop.hybrid_pack');
  }

  const showSelectVariations =
    (isAdvancedPack || isHybridPack) &&
    (!packVariations || packVariations?.length === 0);
  const showProductsInside =
    (isAdvancedPack || isHybridPack) && packVariations?.length > 0;

  const numberOfProducts = isHybridPack
    ? (parentProduct?.packVariations?.reduce(
        (acc, variation) => acc + (variation.quantity ?? 1),
        0,
      ) ?? 0) +
      (parentProduct?.multiPackVariationsAvailable?.reduce(
        (acc, variation) => acc + (variation.amountVariationsToChoose ?? 1),
        0,
      ) ?? 0)
    : amountVariationsPerAdvancedPack;
  return (
    <div className="product-info">
      <img src={isPack ? images[0]?.thumb : icon?.thumb} alt={name} />
      <div className="information">
        {isPack ? <span className="badge-pack">{title}</span> : null}
        <h4 className="product-name">{name}</h4>
        {isOutOfStock ? (
          <span className="text-danger">{t('product.no.stock')}</span>
        ) : null}
        {notAvailableInCountry ? (
          <span className="text-danger">
            {t('shop.checkout.availability.products.variation')}
          </span>
        ) : null}
        {showSelectVariations ? (
          <button
            type="button"
            className="select-products btn-select-products"
            data-pack={JSON.stringify(item)}
          >
            <div className="icon-wrapper">
              <i className="la la-plus" />
            </div>
            <div className="label-wrapper">
              <p className="label-content">{t('btn.selectYourProducts')}</p>
            </div>
          </button>
        ) : null}
        {showProductsInside ? (
          <button
            type="button"
            className="inside-products btn-products-inside"
            data-pack={JSON.stringify(item)}
          >
            {t('advancedPack.productsInside', numberOfProducts)}
          </button>
        ) : null}
      </div>
    </div>
  );
}

ProductItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    isPack: PropTypes.bool,
    name: PropTypes.string,
    isOutOfStock: PropTypes.string,
    packType: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
    icon: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
    packVariations: PropTypes.arrayOf(
      PropTypes.shape(ProductVariationsProp.propType),
    ),
    amountVariationsPerAdvancedPack: PropTypes.number,
  }).isRequired,
};

export default translate(ProductItem);
